import { Route, Switch } from "react-router-dom";

import AddTicketPage from "../AddTicket";
import NotFoundPage from "../NotFound";
import React from "react";
import TicketListPage from "../TicketList";

const Admin = () => {
  return (
    <Switch>
      <Route path="/admin/tickets" exact>
        <TicketListPage />
      </Route>
      <Route path="/admin/tickets/add" exact>
        <AddTicketPage />
      </Route>
      <Route path="/admin/tickets/:email">
        <AddTicketPage />
      </Route>
      <Route>
        <NotFoundPage />
      </Route>
    </Switch>
  );
};

export default Admin;
